/**
 *  绑定Ukey接口文档
 */
import { Method } from '../core';
import { API, SOURCE } from '../config';

const api = API;

export default {
  // 绑定接口
  bindUkey: {
    url: `${api}/rest/v1/cert/ukey/bind`,
    method: Method.POST,
    body: {
      certBase64: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 获取证书列表
  getCertList: {
    url: `${api}/rest/v1/accountcert/list`,
    method: Method.GET,
    body: {
      type: {
        $type: Number,
        $required: true
      },
      page: {
        $type: Number,
        $required: true
      },
      pageSize: {
        $type: Number,
        $required: true
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
   },
  // 解除绑定ukey
  UnbindUkey: {
    url: `${api}/rest/v1/cert/ukey/unbind`,
    method: Method.DELETE,
    body: {
      certId: {
        $type: Number,
        $required: true
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 查看未来一个月内失效的证书
  getExpireCertList: {
    url: `${api}/rest/v1/accountcert/expire`,
    method: Method.GET,
    body: {
      expireDays: {
        $type: Number,
        $required: true
      },
      page: {
        $type: Number,
        $required: true
      },
      pageSize: {
        $type: Number,
        $required: true
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
   },
   //  Ukey签署hash值获取
  getHash: {
    url: `${api}/rest/v1/ukeySign/hash`,
    method: Method.POST,
    body: {
      participantId: {
        $type: String,
        $required: true
      },
      flowDocId: {
        $type: String,
        $required: true
      },
      pos: {
        $type: Object,
        $required: true
      },
      certBase64: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // Ukey签署签名值及hash值合成
  mergeHash: {
    url: `${api}/rest/v1/ukeySign/merge`,
    method: Method.POST,
    body: {
      participantId: {
        $type: String,
        $required: true
      },
      flowDocId: {
        $type: String,
        $required: true
      },
      signature: {
        $type: String,
        $required: true
      },
      isCompleted: {
        $type: Number,
        $required: false
      },
      certSN: {
        $type: String,
        $required: false
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 更改签署状态
  changeStatus: {
    url: `${api}/rest/v1/ukeySign/done`,
    method: Method.PUT,
    body: {
      participantId: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 通过证书序列号判断是否绑定
  haveBindUkey: {
    url: `${api}/rest/v1/accountcert/haveBindUkey`,
    method: Method.GET,
    body: {
      sn: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 批量签署-获取hash
  getBatchHash: {
    url: `${api}/rest/v1/ukeySign/batch/hash`,
    method: Method.POST,
    body: {
      participantIdList: {
        $type: Array,
        $required: true
      },
      pos: {
        $type: Object,
        $required: true
      },
      certBase64: {
        $type: String,
        $required: true
      },
      positioned: {
        $type: Number,
        $required: true
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 批量签署-签名值合成
  mergeBatchHash: {
    url: `${api}/rest/v1/ukeySign/batch/merge`,
    method: Method.POST,
    body: {
      participantIdList: {
        $type: Array,
        $required: true
      },
      signatureList: {
        $type: Array,
        $required: true
      },
      isCompleted: {
        $type: Number,
        $required: false
      },
      certSN: {
        $type: String,
        $required: false
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 批量签署-完善签署
  batchDone: {
    url: `${api}/rest/v1/ukeySign/batch/done`,
    method: Method.PUT,
    body: {
      participantIdList: {
        $type: Array,
        $required: true
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/resource-api/api/bindUkey.js